const LivingDinningIcon = ({ width = 20 }) => (
  <svg width={width} height={width} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 7C4.355 7 3 8.355 3 10V12.188C1.844 12.605 1 13.707 1 15V26H3V24H29V26H31V15C31 13.707 30.156 12.605 29 12.187V10C29 8.355 27.645 7 26 7H6ZM6 9H26C26.555 9 27 9.445 27 10V12.188C25.844 12.605 25 13.707 25 15V17H7V15C7 13.707 6.156 12.605 5 12.187V10C5 9.445 5.445 9 6 9ZM4 14C4.555 14 5 14.445 5 15V19H27V15C27 14.445 27.445 14 28 14C28.555 14 29 14.445 29 15V22H3V15C3 14.445 3.445 14 4 14Z" fill="currentColor" />
  </svg>
);

export default LivingDinningIcon;